export default {
  GET_GUIDES_INIT: (state) => {
    state.getGuides.loading = true;
    state.getGuides.error = null;
  },
  SET_GUIDES: (state, payload) => {
    state.guides = payload.guides;
    state.guideFetchDate = new Date();
    state.guideFetchLanguage = payload.language;
  },
  SET_GET_GUIDES_ERROR: (state, payload) => {
    state.getGuides.error = payload;
  },
  SET_GET_GUIDES_LOADING: (state, payload) => {
    state.getGuides.loading = payload;
  },
  SET_GUIDE_BY_GROUP: (state, payload) => {
    state.guideByGroup.data = payload;
  },
  SET_GET_GUIDE_BY_GROUP_ERROR: (state, payload) => {
    state.guideByGroup.error = payload;
  },
  SET_GET_GUIDE_BY_GROUP_LOADING: (state, payload) => {
    state.guideByGroup.loading = payload;
  },
};
